import RepositoryFactory from "../../admin/apis/index";
const ecomCoupon = RepositoryFactory.ecomCoupon;

export default {
  addCoupon({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ecomCoupon.addCoupon(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getCoupon({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ecomCoupon.getCoupon(payload);
        commit("SET_COUPON", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateCoupon({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ecomCoupon.updateCoupon(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteCoupon({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ecomCoupon.deleteCoupon(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
